import type { SquishLayout } from '@usespaceui/squishmoji';
import { containAvatarGaze } from './avatar-gaze-containment';

type Point = { x: number; y: number };
type Bounds = { left: number; top: number; width: number; height: number };

/** Follow across the face, clamped to the current shape and fitted eyes. */
export function voiceAvatarGaze(
  pointer: Point,
  bounds: Bounds,
  layout?: SquishLayout
): Point {
  if (
    ![...Object.values(pointer), ...Object.values(bounds)].every(
      Number.isFinite
    ) ||
    bounds.width <= 0 ||
    bounds.height <= 0
  )
    return { x: 0, y: 0 };
  const dx = pointer.x - bounds.left - bounds.width / 2;
  const dy = pointer.y - bounds.top - bounds.height / 2;
  const distance = Math.max(
    Math.hypot(dx, dy),
    Math.max(bounds.width, bounds.height) * 4
  );
  const target = { x: (dx / distance) * 52, y: (dy / distance) * 40 };
  return layout ? containAvatarGaze(target, layout) : target;
}
